import { useMonitorStore } from '../lib/monitorStore';

export function ConnectionIndicator() {
  const { connectionStatus, email, clearAuth } = useMonitorStore();

  const statusText = {
    disconnected: 'Disconnected',
    connecting: 'Connecting...',
    connected: 'Connected',
  }[connectionStatus];

  return (
    <div className="connection-status">
      <div className={`connection-dot ${connectionStatus}`} />
      <span>{statusText}</span>
      {email && (
        <>
          <span style={{ color: 'var(--text-muted)', margin: '0 8px' }}>|</span>
          <span style={{ color: 'var(--text-secondary)' }}>{email}</span>
          <button
            onClick={() => clearAuth()}
            style={{
              background: 'transparent',
              border: 'none',
              color: 'var(--text-secondary)',
              cursor: 'pointer',
              marginLeft: 8,
              fontSize: 12,
            }}
          >
            Sign out
          </button>
        </>
      )}
    </div>
  );
}
